import React from 'react'

import { NotificationsDrawer } from 'app/layout'
import { useAppNotificationsDrawer } from "./@hooks";

export default function AppNotificationsDrawer() {

    const { totalAlertsNotifications, isOpenAlertsDrawer, setOpenDrawer } = useAppNotificationsDrawer()

    return <NotificationsDrawer
        data={totalAlertsNotifications}
        openNotifications={isOpenAlertsDrawer}
        setOpenNotifications={setOpenDrawer}
    />
}